<style>
 .text-white {
    color:white !important;
    cursor: pointer;
 }
</style>
<template>
        <!-- footer-section start-->
        <div class="footer-section">
            <div class="container py-4">
                <div class="row text-center text-md-start">
                <div class="col-12 col-md-6 mb-2 mb-md-0">
                    <p class="mb-0 footer-links">
                    <a :href="privacy_policy">Privacy Policy</a> |
                    <!-- <a href="https://visamedical.kimshealth.org/refund-policy">Refund Policy</a> | -->
                    <a :href="terms_and_conditions">Terms & Conditions</a> |
                    <a :href="trackAppointment">Track Appointment(s)</a>
                    </p>
                </div>
                <div class="col-12 col-md-6 text-md-end">
                    <p class="mb-0 text-white">
                        Copyright © 2025, Designed & Developed by <a href="https://www.kenland.in/" class="mx-2 text-decoration-none text-white" >Kenland IT Solutions Pvt. Ltd.</a>
                    </p>
                </div>
                </div>
            </div>
        </div>
        <!-- footer-section end-->
</template>
<script>
 export default {
    data() {
        return {
            trackAppointment : '/trackAppointment',
            privacy_policy : '/privacy-policy',
            terms_and_conditions : '/terms-conditions',
        };
    }
 }
</script>